export default __webpack_public_path__ + "static/media/blueAvtarLogo.aea2ff7f.svg";